export const GridClass = {
	root: 'gov-grid',
}

export const GridItemClass = {
	root: 'gov-grid-item',
}
